import { createContext } from 'react'

type Overrides = Record<string, string>

export const BreadcrumbOverridesContext = createContext<{
  overrides: Overrides
  set: (segment: string, label: string) => void
  remove: (segment: string) => void
}>({ overrides: {}, set: () => {}, remove: () => {} })
